import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'
import ListAction from 'core/actions/ListAction'

const { kubernetes } = ApiClient.getInstance()

export const kaapiHostedControlPlaneActions = ActionsSet.make<DataKeys.KaapiHostedControlPlanes>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiHostedControlPlanes],
  cacheKey: DataKeys.KaapiHostedControlPlanes,
})

export const listKaapiHostedControlPlanes = kaapiHostedControlPlaneActions.add(
  new ListAction<DataKeys.KaapiHostedControlPlanes, { namespace: string }>(
    async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to list Kaapi HostedControlPlanes', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiHostedControlPlanes)
    },
  ),
)
